




import Vue from 'vue';
import Component from 'vue-class-component';
import store from '@/store';

@Component
export default class ThemeSwitch extends Vue {
  set mode(mode) {
    store.commit('toggleDarkTheme');
  }

  get mode() {
    return this.$store.state.theme.dark;
  }


}
